import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMinus, faPlus } from "@fortawesome/pro-regular-svg-icons"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        display: "flex",
        alignItems: "center",
    },
    box: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "2.75rem",
        flex: "none",
    },
    boxDark: {
        background: theme.palette.tailwind.slate[900],
        color: theme.palette.common.white,
        fontSize: "0.875rem",
        lineHeight: "1",
        width: "2.75rem",
        cursor: "pointer",
    },
    boxLeft: {
        borderRadius: "0.5rem 0px 0px 0.5rem",
    },
    boxRight: {
        borderRadius: "0px 0.5rem 0.5rem 0px",
    },
    countBox: {
        padding: "0 1.25rem",
        fontSize: "1rem",
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
    },
}))

type PackageCounterProps = {
    count: number
    handleCounter: (el: number) => void
}

export const PackageCounter = ({ count, handleCounter }: PackageCounterProps) => {
    const { classes, cx } = useStyles()

    const handleIncrement = () => {
        handleCounter(count + 1)
    }

    const handleDecrement = () => {
        // Prevents the count from going below 0
        handleCounter(Math.max(count - 1, 0))
    }

    return (
        <Box className={classes.wrap}>
            <Box className={cx(classes.box, classes.boxDark, classes.boxLeft)} onClick={handleDecrement}>
                <FontAwesomeIcon icon={faMinus} />
            </Box>
            <Box className={cx(classes.box, classes.countBox)}>{count}</Box>
            <Box className={cx(classes.box, classes.boxDark, classes.boxRight)} onClick={handleIncrement}>
                <FontAwesomeIcon icon={faPlus} />
            </Box>
        </Box>
    )
}
